export default __webpack_public_path__ + "static/media/logo-white.a050b26d.svg";